import { TimePicker } from "@mui/x-date-pickers";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { format, parse } from "date-fns";

import { PickerTextInput } from "./PickerTextInput";

interface InterviewTimePickerFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
}

export function InterviewTimePickerField(props: InterviewTimePickerFieldProps) {
  const { value, onChange, error, label, ariaLabel, disabled } = props;
  const timeValue = parse(value, "HH:mm", new Date());

  return (
    <TimePicker
      skipDisabled
      ampm
      label={label}
      value={timeValue}
      disabled={disabled}
      slots={{ textField: PickerTextInput }}
      slotProps={{
        textField: {
          size: "small",
          inputProps: {
            "aria-label": ariaLabel,
          },
          sx: {
            width: { xs: "100%", sm: "9rem" },
            minWidth: 0,
          },
          error,
        },
      }}
      minutesStep={15}
      onChange={(newValue) => {
        if (newValue) {
          onChange(format(newValue, "HH:mm"));
        }
      }}
    />
  );
}
